import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line } from "recharts";

const COLORS = ["#2C3D30", "#4A5D4E", "#C86F58", "#575A57", "#8FA087", "#B5B0A2", "#3E5241", "#7A8B76", "#A0431F"];

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/summary").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-ink-soft">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="analytics">
      <div>
        <div className="overline">Analytics</div>
        <h1 className="font-serif text-4xl mt-1">Signals</h1>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card title="Contacts by Category">
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={d.by_category}>
              <CartesianGrid stroke="#E5E1D8" strokeDasharray="3 3" />
              <XAxis dataKey="category" stroke="#575A57" tick={{ fontSize: 11 }} />
              <YAxis stroke="#575A57" />
              <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E5E1D8" }} />
              <Bar dataKey="count" fill="#2C3D30" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card title="Donations by Fund">
          {d.by_fund.length ? (
            <ResponsiveContainer width="100%" height={280}>
              <PieChart>
                <Pie data={d.by_fund} dataKey="amount" nameKey="fund" cx="50%" cy="50%" outerRadius={100} label>
                  {d.by_fund.map((entry) => <Cell key={entry.fund} fill={COLORS[Math.abs(entry.fund.charCodeAt(0)) % COLORS.length]} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : <div className="text-ink-soft h-[280px] flex items-center justify-center">No donations yet.</div>}
        </Card>
        <Card title="Applications by Month" className="lg:col-span-2">
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={d.applications}>
              <CartesianGrid stroke="#E5E1D8" strokeDasharray="3 3" />
              <XAxis dataKey="month" stroke="#575A57" />
              <YAxis stroke="#575A57" />
              <Tooltip />
              <Line type="monotone" dataKey="volunteers" stroke="#2C3D30" strokeWidth={2} dot={{ r: 4 }} />
              <Line type="monotone" dataKey="retreats" stroke="#C86F58" strokeWidth={2} dot={{ r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
}

function Card({ title, children, className = "" }) {
  return (
    <div className={`bg-admin-surface border border-line rounded-xl p-6 ${className}`}>
      <div className="overline mb-4">{title}</div>
      {children}
    </div>
  );
}
